import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Pane, Flex, Text, TextInput, Label, Content, Button, Toast } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import { TitleBar } from '@leverege/ui-plugin';
import I18N from '@leverege/i18n';
import { Users, Auth } from '@leverege/api-redux';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const screenIcon = 'https://storage.googleapis.com/molten-ui-assets/profile-title.png';
const {
  t
} = I18N.ns('molten.screens.account.ProfileScreen');
class ProfileScreen extends React.Component {
  constructor(props) {
    super(props);
    const {
      profile
    } = this.props;
    this.state = {
      name: profile.name
    };
  }
  static propTypes = {
    showHeader: PropTypes.bool
  };
  static defaultProps = {
    showHeader: true
  };
  componentDidMount() {
    const {
      setTitle,
      setIcon
    } = this.props;
    if (setTitle) setTitle({
      data: t('title')
    });
    if (setIcon) setIcon({
      data: Config.get('ProfileScreen', 'screenIcon', screenIcon)
    });
  }
  onCancel = () => {
    const {
      profile
    } = this.props;
    this.setState({
      name: profile.name
    });
  };
  onSubmit = async () => {
    const {
      name
    } = this.state;
    const {
      auth,
      dispatch
    } = this.props;
    try {
      await dispatch(Users.update(auth.profile.id, {
        name
      }));
      await dispatch(Auth.renew());
      Toast.success(t('successToast'));
    } catch (ex) {
      Toast.error(t('errorToast'));
    }
  };
  renderForm = validator => {
    const {
      profile
    } = this.props;
    const {
      name
    } = this.state;
    return /*#__PURE__*/_jsx(Flex, {
      variant: "colL",
      style: {
        maxWidth: '704px'
      },
      children: /*#__PURE__*/_jsxs(Pane, {
        layout: "flex:colL",
        variant: "contentBorder",
        children: [/*#__PURE__*/_jsx(Flex, {
          variant: "colL",
          children: /*#__PURE__*/_jsxs(Flex, {
            variant: "setting|colM",
            children: [/*#__PURE__*/_jsx(Text, {
              variant: "sectionTitle|title",
              children: Config.get('ProfileScreen', 'usernameTitle', t('usernameTitle'))
            }), /*#__PURE__*/_jsx(Text, {
              variant: "sectionBody|subtitle",
              children: Config.get('ProfileScreen', 'usernameSubtitle', t('usernameSubtitle'))
            })]
          })
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "setting|colM",
          children: [/*#__PURE__*/_jsx(Label, {
            variant: "inputTitle|title",
            children: Config.get('ProfileScreen', 'usernameLabel', t('usernameLabel'))
          }), /*#__PURE__*/_jsx(TextInput, {
            disabled: true,
            variant: "inputGrow",
            value: profile.username
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "setting|colM",
          children: [/*#__PURE__*/_jsx(Label, {
            variant: "inputTitle|title",
            children: Config.get('ProfileScreen', 'nameLabel', t('nameLabel'))
          }), /*#__PURE__*/_jsx(TextInput, {
            variant: "inputGrow",
            eventData: "name",
            onChange: ({
              value,
              data
            }) => this.setState({
              [data]: value
            }),
            value: name
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "rowMEnd",
          children: [/*#__PURE__*/_jsx(Button, {
            variant: "secondary",
            type: "button",
            onClick: this.onCancel,
            children: t('cancel')
          }), /*#__PURE__*/_jsx(Button, {
            variant: "primary",
            disabled: !name || name === profile.name,
            onClick: this.onSubmit,
            children: t('submit')
          })]
        })]
      })
    });
  };
  render() {
    const {
      showHeader
    } = this.props;
    return /*#__PURE__*/_jsxs(Content, {
      children: [showHeader ? /*#__PURE__*/_jsx(Content.Header, {
        children: /*#__PURE__*/_jsx(TitleBar, {
          variant: "screenTitle",
          title: Config.get('ProfileScreen', 'screenTitle', t('title')),
          icon: Config.get('ProfileScreen', 'screenIcon', screenIcon)
        })
      }) : null, /*#__PURE__*/_jsx(Content.Area, {
        variant: "screenContent",
        children: this.renderForm()
      })]
    });
  }
}
export default connect(state => ({
  auth: state.auth,
  profile: state.auth.profile
}))(ProfileScreen);